import {useMemo} from 'react';
import {breadcrumbsFor} from '@tenant/core/routes';
import useCurrentRoute from './use-current-route';
import {useBreadcrumbContributions} from '../features/navigation/breadcrumbs-context';

function useRouteBreadcrumbs() {
  const {route, routes, params} = useCurrentRoute();
  const {loading, overrides, append} = useBreadcrumbContributions();

  const crumbs = useMemo(() => {
    if (route?.showBreadcrumbs === false) {
      return [];
    }
    const trail = breadcrumbsFor(routes, route, params).map(crumb => {
      const override = overrides[crumb.slug];
      const {label, href} =
        typeof override === 'string' ? {label: override} : override || {};
      return {...crumb, label: label || crumb.label, href: href || crumb.href};
    });
    const all = [...trail, ...append];
    return all.map((crumb, index) => ({
      ...crumb,
      active: index === all.length - 1,
    }));
  }, [routes, route, params, overrides, append]);

  return {crumbs, loading};
}

export default useRouteBreadcrumbs;
